export function translate(key) {
    return window.translations?.[key] ?? key
}

export function createAnimationFrameHandler(callback) {
    let animationFrameId = null

    function wrapper(...args) {
        const self = this

        function exec() {
            callback.apply(self, args)
        }

        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId)
        }

        animationFrameId = requestAnimationFrame(exec)
    }

    return wrapper
}
